const table = [   
  {
    prop: 'name_module',
    label: 'Nombre',
    minWidth: 150
  },
  {
    prop: 'url',
    label: 'URL',
    minWidth: 150
  },
  {
    prop: 'description',
    label: 'Descripción',
    minWidth: 200
  },
  {
    prop: 'parent_label',
    label: 'Padre',
    minWidth: 120
  },
  {
    prop: 'type',
    label: 'Tipo',
    minWidth: 120
  }
]
export default table
